import { Component } from 'react'

import PropTypes from 'prop-types'

import { formatDropdownOptions } from 'utils/formatters'
import { addTitleToEvents } from 'utils/transformations/orders'

import Dropdown from 'components/Core/Dropdown/Dropdown'
import Modal from 'components/Core/Modal'

import messages from './EditEventModal.messages'

export default class EditEventModal extends Component {
  state = {
    selectedOption: null,
  }

  handleOnSubmit = () => {
    const {
      setPageLoaderActive,
      handleEditEvents,
      selectedOrders,
      renderActionsToasterMessage,
      handleResetOrder,
    } = this.props
    const selectedOrderIds = selectedOrders.map((order) => order.id)
    const { selectedOption } = this.state
    setPageLoaderActive(true)

    handleEditEvents(selectedOrderIds, selectedOption)
      .then(({ data }) => {
        setPageLoaderActive(false)
        renderActionsToasterMessage(
          data.batchUpsertOrderEvents.updatedOrders.length,
          data.batchUpsertOrderEvents.notUpdatedOrders.length,
        )
        handleResetOrder()
      })
      .catch((error) => {
        console.error(error)
        setPageLoaderActive(false)
      })
  }

  handleOnChange = (event, data) => {
    this.setState({ selectedOption: data.value })
  }

  render() {
    return (
      <Modal
        title={messages.editEvent}
        primaryActionLabel={messages.update}
        primaryActionOnClick={this.handleOnSubmit}
        primaryDisabled={!this.state.selectedOption}
        open
        onClose={this.props.onClose}
      >
        <label htmlFor="orderEvents">{messages.selectOption}</label>
        <Dropdown
          id="orderEvents"
          search
          placeholder={messages.selectOne}
          options={formatDropdownOptions(
            addTitleToEvents(this.props.orderEvents),
          ).map((option) => ({ ...option, className: 'notranslate' }))}
          onChange={this.handleOnChange}
          className={this.state.selectedOption ? 'notranslate' : ''}
        />
      </Modal>
    )
  }
}

EditEventModal.propTypes = {
  orderEvents: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedOrders: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleEditEvents: PropTypes.func.isRequired,
  handleResetOrder: PropTypes.func.isRequired,
  setPageLoaderActive: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  renderActionsToasterMessage: PropTypes.func.isRequired,
}
